import { ErrorMessage } from '@hookform/error-message';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Col, Input, Row } from 'reactstrap';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { SchedulingAudioSelectorWrapper } from './styled';
import FormTooltip from 'components/Inputs/FormTooltip';
import { MdClear } from 'react-icons/md';

function SchedulingAudioSelector({
  soundSchedule,
  setSoundSchedule,
  base64SoundSchedule,
  setBase64SoundSchedule,
  tooltipTextSchedule,
  setIsValidSoundSchedule,
  errors
}) {
  const { setError } = useForm();
  const [isAudioValidSchedule, setIsAudioValidSchedule] = useState(false);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  useEffect(() => {
    if (base64SoundSchedule) {
      setIsAudioValidSchedule(true);
      setIsValidSoundSchedule(true);
    } else {
      setIsAudioValidSchedule(false);
      setIsValidSoundSchedule(false);
    }
  }, [base64SoundSchedule, setIsValidSoundSchedule]);

  const isFileValidSchedule = (file) => {
    if (!file) {
      setError('sound-schedule', {
        type: 'required',
        message: 'Selecione um arquivo de áudio'
      });
      return false;
    }
    if (file.size > 50000) {
      setError('sound-schedule', {
        type: 'maxLength',
        message: 'Arquivo maior do que 50 Kb'
      });
      return false;
    }
    if (
      ![
        'audio/mpeg',
        'audio/mp3',
        'audio/wav',
        'audio/x-wav',
        'audio/x-gsm',
        'audio/ogg'
      ].includes(file.type)
    ) {
      return false;
    }
    return true;
  };

  const changeFileSchedule = (event) => {
    const fileSchedule = event.target.files[0];
    if (!fileSchedule) {
      setIsAudioValidSchedule(false);
      setIsValidSoundSchedule(false);
      setSoundSchedule(null);
      setBase64SoundSchedule(null);
      return;
    }

    const isValidSchedule = isFileValidSchedule(fileSchedule);
    setIsAudioValidSchedule(isValidSchedule);
    setIsValidSoundSchedule(isValidSchedule);
    setSoundSchedule(fileSchedule);

    if (isValidSchedule) {
      const readerSchedule = new FileReader();
      readerSchedule.onloadend = () => {
        setBase64SoundSchedule(readerSchedule.result);
      };
      readerSchedule.readAsDataURL(fileSchedule);
    } else {
      setBase64SoundSchedule(null);
    }
  };

  const handleClearAudioSchedule = () => {
    setSoundSchedule(null);
    setBase64SoundSchedule(null);
    setIsAudioValidSchedule(false);
    setIsValidSoundSchedule(false);
    localStorage.removeItem('@flexuc/schedulingAudio');
  };

  const errorFormMessageSchedule = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <SchedulingAudioSelectorWrapper>
      <Row className="mb-3">
        <Col sm="12" style={{ display: 'flex', alignItems: 'center' }}>
          <strong>Áudio das notificações de agendamento</strong>
          <FormTooltip text={tooltipTextSchedule} />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="12">
          <label className="form-control-label d-block">
            Áudio (mp3, wav, gsm, ogg, limite de 50 Kb)*
          </label>
          <label
            htmlFor="sound-schedule"
            className="audio-button-select-style"
            style={buttonStyle(systemConfiguration.primary_color)}
          >
            Selecionar um arquivo
          </label>
          <Input
            style={{ display: 'none' }}
            type="file"
            id="sound-schedule"
            name="sound-schedule"
            onChange={changeFileSchedule}
            accept="audio/mp3, audio/mpeg, audio/wav, audio/x-wav, audio/x-gsm, audio/ogg"
          />
          <ErrorMessage
            errors={errors}
            name="sound-schedule"
            render={({ message }) => errorFormMessageSchedule(message)}
          />
        </Col>
        {isAudioValidSchedule && (base64SoundSchedule || soundSchedule) && (
          <Col
            sm="9"
            style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}
          >
            <audio
              src={
                base64SoundSchedule ||
                (soundSchedule ? window.URL.createObjectURL(soundSchedule) : '')
              }
              controls
              style={{ width: '100%', maxWidth: '20rem' }}
            />
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleClearAudioSchedule}
              style={{
                marginLeft: '1rem',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <MdClear title="Remover arquivo selecionado" />
            </button>
          </Col>
        )}
      </Row>
    </SchedulingAudioSelectorWrapper>
  );
}

export default SchedulingAudioSelector;
